import { BaseModel } from 'core/base.model';

import { __NEW__ } from '@core/constants/constants';

export class TextContent extends BaseModel {
  name: string;
  content: string;

  constructor() {
    super(__NEW__);
    this.name = 'content.txt';
    this.content = 'c2V1IGNvbnRldWRvIGFxdWk=';
  }
}
